import { Formik, FormikProps } from "formik";
import { isEqual } from "lodash";
import { ChangeEvent, useRef, useState } from "react";
import { useMutation } from "react-query";
import AGButton from "../../../components/Button";
import AGInput from "../../../components/Input";
import AGModal from "../../../components/Modal";
import { useNotification } from "../../../components/Notification";
import { FirmProfile } from "../../../models";
import { videoSchema } from "../../../Schema/CommerceCompassSchema";
import { httpPUT } from "../../../utils/ajaxHelper";
import { FormContainer } from "./addVideoModal.styled";

export interface AddProchureModalProps {
	visible: boolean;
	toggleModal: () => void;
	data: FirmProfile;
}
const AddVideoModal = ({
	visible,
	toggleModal,
	data,
}: AddProchureModalProps) => {
	const handleClose = () => {
		toggleModal();
	};

	const { showNotification } = useNotification();
	const formRef = useRef<FormikProps<any>>(null);
	const [isDataChanged,setIsDataChanged] = useState<boolean>(false);

	const { mutate: submitForm } = useMutation(
		(data: FormData) =>
			httpPUT({
				url: "/FirmProfile",
				data: data,
			}),
		{
			onSuccess: (rs) => {
				handleClose();
			},
			onError: (rs) => {
				showNotification("Upload Failed", "Error");
			},
		},
	);

	if (!data) {
		return null;
	}

	const intitialValues = {
		fkFirmId: data?.fkFirmId,
		logoName: data?.logoName,
		logoPart: data?.logoPart,
		backgroundName: data?.backgroundName,
		backgroundPart: data?.backgroundPart,
		description: data?.description,
		tagLine: data?.tagLine,
		brochureName: data?.brochureName,
		brochurePath: data?.brochurePath,
		firmContactstring: data?.firmContactstring,
		videoUrl: data.videoUrl,
		offerorURL: data!.offerorURL,
	}

	return (
		<div>
			<AGModal
				toggleModal={toggleModal}
				title="Organization Video"
				footer={
					<>
						<AGButton
							type="Primary"
							onClick={() => {
								formRef.current?.submitForm();
							}}
							disabled={!isDataChanged}>
							Save
						</AGButton>
					</>
				}
				visible={visible}
				setHeight={280}>
				<FormContainer>
					<Formik
						innerRef={formRef}
						initialValues={
							{
								fkFirmId: data?.fkFirmId,
								logoName: data?.logoName,
								logoPart: data?.logoPart,
								backgroundName: data?.backgroundName,
								backgroundPart: data?.backgroundPart,
								description: data?.description,
								tagLine: data?.tagLine,
								brochureName: data?.brochureName,
								brochurePath: data?.brochurePath,
								firmContactstring: data?.firmContactstring,
								videoUrl: data.videoUrl,
								offerorURL: data!.offerorURL,
							} as any
						}
						validateOnBlur={false}
						validationSchema={videoSchema}
						onSubmit={(values) => {
							const formData = new FormData();
							formData.append("fkFirmId", values.fkFirmId);
							formData.append(
								"description",
								values.description ? values.description.trim() : "",
							);
							formData.append(
								"tagLine",
								values.tagLine ? values.tagLine.trim() : "",
							);
							formData.append(
								"videoUrl",
								values.videoUrl ? values.videoUrl.trim() : "",
							);
							formData.append(
								"offerorURL",
								values.offerorURL ? values.offerorURL.trim() : "",
							);
							submitForm(formData);
						}}>
						{({ setFieldValue, values, errors }) => {
							const isDirty = !isEqual(
								{ ...values
								},
								intitialValues
							);
			
							setIsDataChanged(isDirty);
			
							const hasPdfError =
							typeof errors.pdf === 'string' ? errors.pdf.length > 0 :
							Array.isArray(errors.pdf) ? errors.pdf.length > 0 :
							false;
							
							setIsDataChanged(hasPdfError ? false : isDirty);
							return (
								<form onSubmit={(e) => e.preventDefault()} className="form">
									<div className="form-input">
										<label className="label-title-second text:[14px]">
											If the organization has a relevant marketing video, provide the URL/ YouTube.
										</label>
										<div className="video-input">
											<AGInput
												className="w-full text:[14px] video-input-ag"
												placeholder="Enter video URL"
												value={values.videoUrl}
												onChange={(
													e: ChangeEvent<HTMLInputElement>,
												) => {
													setFieldValue(
														"videoUrl",
														e.target.value,
													);
												}}
											/>
											{errors.videoUrl && (
												<div className="error">
													{errors.videoUrl.toString()}
												</div>
											)}
										</div>
									</div>
								</form>
							);
						}}
					</Formik>
				</FormContainer>
			</AGModal>
		</div>
	);
};
export default AddVideoModal;
